import { useReducer } from 'react'
import GlobalSearchState, { globalSearchStateReducer, GLOBAL_SEARCH_INITIAL_STATE, GlobalSearchAction } from 'contexts/GlobalSearch/GlobalSearchState'

export default function useGlobalSearchContext(initialState: GlobalSearchState = GLOBAL_SEARCH_INITIAL_STATE) {
  const [globalSearchState, globalSearchDispatch] = useReducer<GlobalSearchState, [GlobalSearchAction]>(globalSearchStateReducer, initialState)

  return { globalSearchState, globalSearchDispatch }
}
